import {Injectable} from '@angular/core';
import {AppPreferences} from "../../domain/models";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PreferencesService {

  public appPreferences: AppPreferences = new AppPreferences();

  prefName = "expo_app_prefs"

  constructor() {
    if (environment.isStage) this.prefName = "expo_app_prefs"; else this.prefName = "expo_app_prefs_stage"
    this.appPreferences = JSON.parse(localStorage.getItem(this.prefName))
    if (this.appPreferences == null) this.setAppPreferences(new AppPreferences())
    this.reloadPreferences()
  }

  public setAppPreferences(prefs: AppPreferences) {
    localStorage.setItem(this.prefName, JSON.stringify(prefs))
    this.appPreferences = prefs;
  }

  public reloadPreferences() {
    this.appPreferences = JSON.parse(localStorage.getItem(this.prefName))
  }

}
